import '../styles/Loader.css'
import { useGlobalContent } from '../context/helpersProvider'

export const Loader = (props: any) => {
  const { showLoading } = useGlobalContent()
  return (
    <>
      {showLoading === 'true' && (
        <div className='overlay-spinner'>
          <div className='loader-in'>
            <div className='spinner'></div>
          </div>
        </div>
      )}
    </>
  )
}
